// -----------------------------------------------------------------------------
// src/pages/BlitzPay/components/ActivityView.jsx
// -----------------------------------------------------------------------------
import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  Link,
  Divider,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,   // ✅ NEW
  Paper,            // ✅ NEW
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import EditIcon from "@mui/icons-material/Edit";
import { StyledTableRow } from "../../../Utils/styledcell";

const ActivityView = ({ rows, isMobile, onApprove, onEdit, formatAmount }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleMenuOpen = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  const handleEdit = () => {
    if (selectedRow) onEdit(selectedRow);
    handleMenuClose();
  };

  const handleApprove = () => {
    if (selectedRow) onApprove(selectedRow.invoiceId);
    handleMenuClose();
  };

  /* ------------------------------ MOBILE CARDS ------------------------------ */
  if (isMobile) {
    return (
      <Box sx={{ display: "grid", gridTemplateColumns: "1fr", gap: 2 }}>
        {rows.map((item, i) => (
          <Card
            key={i}
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: 2,
              boxShadow: "0px 4px 6px rgba(0,0,0,0.05)",
              transition: "transform .3s",
              "&:hover": { transform: "translateY(-3px)" },
            }}
          >
            <CardContent>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography variant="subtitle1" fontWeight={600}>
                  {item.name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {new Date(item.date).toLocaleDateString()}
                </Typography>
              </Box>

              <Typography variant="body2" color="text.secondary">
                {item.type} • {item.po_number}
              </Typography>

              <Box sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
                <Typography variant="body1" fontWeight={500}>
                  {formatAmount(item.amount)}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color:
                      item.status === "pending"
                        ? "#ed6c02"
                        : item.status === "paid"
                        ? "#2e7d32"
                        : "#9e9e9e",
                  }}
                >
                  {item.status}
                </Typography>
              </Box>

              {item.notes && (
                <Typography variant="body2" sx={{ mt: 1, fontStyle: "italic" }}>
                  {item.notes}
                </Typography>
              )}

              <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
                {item.link !== "#" ? (
                  <Link href={item.link} target="_blank" underline="hover">
                    View Details
                  </Link>
                ) : (
                  <Box />
                )}

                <IconButton size="small" onClick={(e) => handleMenuOpen(e, item)}>
                  <MoreVertIcon />
                </IconButton>
              </Box>
            </CardContent>
          </Card>
        ))}
      </Box>
    );
  }

  /* ------------------------------ DESKTOP TABLE ----------------------------- */
  return (
    <TableContainer component={Paper} elevation={1} sx={{ mb: 2 }}>
      <Table sx={{ minWidth: 650 }} aria-label="all activity table">
        <TableHead>
          <TableRow>
            <TableCell>Type</TableCell>
            <TableCell>Name</TableCell>
            <TableCell align="center">PO #</TableCell>
            <TableCell align="center">Amount</TableCell>
            <TableCell align="center">Status</TableCell>
            <TableCell align="center">Date</TableCell>
            <TableCell>Notes</TableCell>
            <TableCell align="center">Link</TableCell>
            <TableCell align="center">Actions</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {rows.map((item, i) => (
            <StyledTableRow key={i}>
              <TableCell>{item.type}</TableCell>
              <TableCell>{item.name}</TableCell>
              <TableCell align="center">{item.po_number}</TableCell>
              <TableCell align="center">{formatAmount(item.amount)}</TableCell>
              <TableCell
                align="center"
                sx={{
                  color:
                    item.status === "pending"
                      ? "#ed6c02"
                      : item.status === "paid"
                      ? "#2e7d32"
                      : "#9e9e9e",
                  fontWeight: 500,
                }}
              >
                {item.status}
              </TableCell>
              <TableCell align="center">
                {new Date(item.date).toLocaleDateString()}
              </TableCell>
              <TableCell>{item.notes}</TableCell>
              <TableCell align="center">
                {item.link !== "#" ? (
                  <Link href={item.link} target="_blank" rel="noopener noreferrer">
                    View
                  </Link>
                ) : (
                  "N/A"
                )}
              </TableCell>
              <TableCell align="center">
                <IconButton size="small" onClick={(e) => handleMenuOpen(e, item)}>
                  <MoreVertIcon />
                </IconButton>
              </TableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>

      {/* Action Menu */}
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
        {selectedRow?.pending && <MenuItem onClick={handleApprove}>Approve</MenuItem>}
        {selectedRow?.editable && (
          <MenuItem onClick={handleEdit}>
            <EditIcon fontSize="small" sx={{ mr: 1 }} />
            Edit
          </MenuItem>
        )}
      </Menu>
    </TableContainer>
  );
};

export default ActivityView;
